import { useState } from "react";

const TabData = [
    "Real estate",
    "New homes",
    "Popular areas",
    "Popular searches",
];

const tabContent = {
    "Real estate": (
        <>
            {/* <h3 className="font-light my-6 !text-[#3D3B40]">Real estate in Nigeria</h3> */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
                <div className="flex flex-col gap-4">
                    <p className=" cursor-pointer">Real estate Lagos</p>
                    <p className=" cursor-pointer">Real estate Abuja</p>
                    <p className=" cursor-pointer">Real estate Harcourt</p>
                    <p className=" cursor-pointer">Real estate Enugu</p>
                    <p className=" cursor-pointer">Real estate Ibadan</p>
                    <p className=" cursor-pointer">Real estate Benin City</p>
                </div>
                <div className="flex flex-col gap-4 lg:-ml-[8px]  xl:ml-[8px]" >
                    <p className=" cursor-pointer">Real estate Kano</p>
                    <p className=" cursor-pointer">Real estate Kaduna</p>
                    <p className=" cursor-pointer">Real estate Uyo</p>
                    <p className=" cursor-pointer">Real estate Warri</p>
                    <p className=" cursor-pointer">Real estate Calabar</p>
                </div>
                <div className="flex flex-col gap-4 lg:-ml-[100px] xl:-ml-[118px] " >
                    <p className=" cursor-pointer">Real estate Owerri</p>
                    <p className=" cursor-pointer">Real estate Abeokuta</p>
                    <p className=" cursor-pointer">Real estate Jos</p>
                    <p className=" cursor-pointer">Real estate Ilorin</p>
                    <p className=" cursor-pointer">Real estate Asaba</p>
                </div>
            </div>
        </>
    ),
    "New homes": (
        <>
            {/* <h3 className="font-light my-6 !text-[#3D3B40]">Build new homes in Nigeria</h3> */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
                <div className="flex flex-col gap-4">
                    <p className=" cursor-pointer">Home builders Lagos</p>
                    <p className=" cursor-pointer">House and land Abuja</p>
                    <p className=" cursor-pointer">Home builders Port Harcourt</p>
                    <p className=" cursor-pointer">House and land Ibadan</p>
                    <p className=" cursor-pointer">New homes in Benin City</p>
                    <p className=" cursor-pointer">Home builders Enugu</p>
                </div>
                <div className="flex flex-col gap-4">
                    <p className=" cursor-pointer">House designs Nigeria</p>
                    <p className=" cursor-pointer">Land for sale Abuja</p>
                    <p className=" cursor-pointer">Affordable homes Lagos</p>
                    <p className=" cursor-pointer">Luxury homes Lekki</p>
                    <p className=" cursor-pointer">New developments Ogun</p>
                </div>
                <div className="flex flex-col gap-4">
                    <p className=" cursor-pointer">Duplex designs Nigeria</p>
                    <p className=" cursor-pointer">Home builders Kaduna</p>
                    <p className=" cursor-pointer">House and land Owerri</p>
                    <p className=" cursor-pointer">Modern homes Asaba</p>
                    <p className=" cursor-pointer">Real estate projects Jos</p>
                </div>
            </div>
        </>
    ),
    "Popular areas": (
        <>
            {/* <h3 className="font-light my-6 !text-[#3D3B40]">Browse popular areas in Nigeria</h3> */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
                <div className="flex flex-col gap-4">
                    <p className=" cursor-pointer">ekki property prices</p>
                    <p className=" cursor-pointer">Ajah property prices</p>
                    <p className=" cursor-pointer">Maitama house prices</p>

                </div>
                <div className="flex flex-col gap-4">
                    <p className=" cursor-pointer">Banana Island prices</p>
                    <p className=" cursor-pointer">Gwarinpa property values</p>
                    <p className=" cursor-pointer">Suburb profiles Lagos</p>
                </div>
                <div className="flex flex-col gap-4">
                    <p className=" cursor-pointer">Ikoyi house prices</p>
                    <p className=" cursor-pointer">Asokoro real estate</p>

                </div>
            </div>
        </>
    ),
    "Popular searches": (
        <>
            {/* <h3 className="font-light my-6 !text-[#3D3B40]">Browse popular property searches</h3> */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                <div className="flex flex-col gap-4">
                    <p className=" cursor-pointer">Nigeria property news</p>
                    <p className=" cursor-pointer">Mortgage calculator Nigeria</p>
                    <p className=" cursor-pointer">Selling property in Lagos</p>
                    <p className=" cursor-pointer">Rent to own</p>
                    <p className=" cursor-pointer">Land documentation guide</p>
                    <p className=" cursor-pointer">Property trends 2025</p>

                </div>
                <div className="flex flex-col gap-4">
                    <p className=" cursor-pointer">Investing in real estate Nigeria</p>
                    <p className=" cursor-pointer">How to buy land in Nigeria</p>
                    <p className=" cursor-pointer">Cost of building in Nigeria</p>
                    <p className=" cursor-pointer">Land Use Act explained</p>
                    <p className=" cursor-pointer">Nigerian property laws</p>
                </div>
                <div className="flex flex-col gap-4">
                    <p className=" cursor-pointer">Stamp duty rates Nigeria</p>
                    <p className=" cursor-pointer">Housing loan options</p>
                    <p className=" cursor-pointer">How much can I borrow Nigeria</p>
                    <p className=" cursor-pointer">Real estate influencers</p>
                    <p className=" cursor-pointer">2025 real estate forecast</p>

                </div>
            </div>
        </>),
};

const FooterTabbing = () => {
    const [activeTab, setActiveTab] = useState(TabData[0]);

    return (
        <div className="rounded-xl mt-5 relative z-10 ">
            <div className="w-full border-b border-[#E5E5E5] flex">
                {TabData.map((tab, index) => (
                    <button
                        key={index}
                        onClick={() => setActiveTab(tab)}
                        className={`flex-1 text-center py-4 text-sm md:text-base font-medium uppercase transition relative
        ${activeTab === tab
                                ? "text-black font-semibold bg-blue-50 rounded-t-2xl"
                                : "hover:text-[#097FE6]"
                            }`}
                    >
                        {tab}

                        {activeTab === tab && (
                            <span className="absolute bottom-0 left-0 w-full h-[2px] bg-[#097FE6]" />
                        )}
                    </button>
                ))}
            </div>
            <div className="my-12 ">{tabContent[activeTab]}</div>
        </div>
    );
}

export default FooterTabbing